import { Location } from "@angular/common";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { ToastService } from "@lib/base/services/toast.service";
import { UserRolesService } from "@lib/core/services/user-roles.service";
import { TranslateService } from "@ngx-translate/core";
import { tap } from "rxjs";

export const RoleGuard = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
    const toastService = inject(ToastService);
    const translateService = inject(TranslateService);
    const router = inject(Router);
    const location = inject(Location);
    const userRoleService = inject(UserRolesService);

    const roles: string[] = route.data["roles"];
    return userRoleService.hasRoles(roles).pipe(
        tap((hasRoles) => {
            if (!hasRoles) {
                translateService.get("shared.error.access-denied").subscribe({
                    next: msg => toastService.error(msg),
                });
                if (router.navigated) {
                    location.back();
                } else {
                    router.navigate([]);
                }
            }
        }),
    );
};
